import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useNotifications } from '../hooks/notification/useNotifications';
import { iconNotification } from '../assets';
import NotificationItem from './notification/NotificationItem';

interface MobileHeaderProps {
  onMenuClick: () => void;
}

const MobileHeader: React.FC<MobileHeaderProps> = ({ onMenuClick }) => {
  const { auth } = useAuth();
  const navigate = useNavigate();
  const [showNotificationModal, setShowNotificationModal] = useState(false);

  const isTeacher = auth.isAuthenticated && auth.userType === 'teacher';

  // 알림 훅 사용 (선생님만 활성화)
  const {
    notifications,
    markAsRead,
    refresh: refreshNotifications
  } = useNotifications('teacher', { enabled: isTeacher });

  const scrollToTop = () => {
    if (auth.isAuthenticated) {
      if (auth.userType === 'teacher') {
        // 모바일에서 선생님은 수업일정관리로 이동
        window.location.href = '/admin/lesson-schedule';
      } else {
        window.location.href = '/user/dashboard';
      }
    } else {
      window.location.href = '/';
    }
  };

  // 읽지 않은 알림 여부
  const hasUnreadNotifications = notifications.some(n => !n.isRead);

  const handleNotificationClick = () => {
    setShowNotificationModal(true);
  };

  const handleNavigate = (path: string) => {
    setShowNotificationModal(false);
    navigate(path);
  };

  return (
    <>
      <header className={`mobile-header mobile-only ${!auth.isAuthenticated ? 'mobile-header-guest' : ''}`}>
        <h1 className="mobile-header-title" onClick={scrollToTop}>
          {auth.isAuthenticated ? 'Dream Drums' : (<>DREAM<span className="logo-accent">DRUMS</span></>)}
        </h1>
        <div className="mobile-header-actions">
          {isTeacher && (
            <button
              className="mobile-notification-btn"
              onClick={handleNotificationClick}
              aria-label="알림"
            >
              <img src={iconNotification} alt="알림" width="20" height="20" />
              {hasUnreadNotifications && (
                <span className="notification-dot" />
              )}
            </button>
          )}
          <button className="mobile-menu-toggle" onClick={onMenuClick} aria-label="메뉴 열기">
            <span className="hamburger-icon">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
        </div>
      </header>

      {/* 알림 모달 */}
      {showNotificationModal && (
        <div className="mobile-notification-modal">
          <div className="notification-modal-overlay" onClick={() => setShowNotificationModal(false)} />
          <div className="notification-modal-content">
            <div className="notification-modal-header">
              <h2>알림</h2>
              <div className="notification-modal-actions">
                <button className="btn btn-sm btn-white" onClick={refreshNotifications}>
                  새로고침
                </button>
                <button className="notification-modal-close" onClick={() => setShowNotificationModal(false)}>
                  ✕
                </button>
              </div>
            </div>
            <div className="notification-modal-body">
              {notifications.length === 0 ? (
                <div className="notification-empty">
                  <p>새로운 알림이 없습니다</p>
                </div>
              ) : (
                <div className="notification-list">
                  {notifications.map((notification) => (
                    <NotificationItem
                      key={notification.id}
                      notification={notification}
                      onMarkRead={markAsRead}
                      onNavigate={handleNavigate}
                      userType="teacher"
                      isForeigner={false}
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MobileHeader;
